import { Box } from "@chakra-ui/react";
import * as React from "react";
import { LuInfo } from "react-icons/lu";

import { Tooltip } from "./tooltip";

export function InfoTip({ content }: { content: React.ReactNode }) {
  return (
    <Tooltip content={content} positioning={{ placement: "top-end" }}>
      <Box
        as="span"
        color="fg.muted"
        cursor={"default" as any}
        display="inline-flex"
        flexShrink="0"
      >
        <LuInfo size="15" />
      </Box>
    </Tooltip>
  );
}
